export default __webpack_public_path__ + "static/media/ots.12791c3a.woff";